import { render, staticRenderFns } from "./buttonPhone.vue?vue&type=template&id=431748be&scoped=true"
import script from "./buttonPhone.vue?vue&type=script&lang=js"
export * from "./buttonPhone.vue?vue&type=script&lang=js"
import style0 from "./buttonPhone.vue?vue&type=style&index=0&id=431748be&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431748be",
  null
  
)

export default component.exports